var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlag1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_15x23_flag_photo",
    "data-name": "15x23 flag photo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4601",
    "data-name": "Rectangle 4601",
    width: 23,
    height: 15,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_93",
    "data-name": "Mask Group 93",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lebanon",
    transform: "translate(0.053 -3.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4683",
    "data-name": "Group 4683"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16022",
    "data-name": "Path 16022",
    d: "M21.18,3.947H1.715A1.715,1.715,0,0,0,0,5.662V7.105H22.895V5.662A1.715,1.715,0,0,0,21.18,3.947Z",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16023",
    "data-name": "Path 16023",
    d: "M0,17.233a1.715,1.715,0,0,0,1.715,1.715H21.18a1.715,1.715,0,0,0,1.715-1.715V15.789H0Z",
    fill: "#ff4b55"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4602",
    "data-name": "Rectangle 4602",
    width: 22.895,
    height: 8.684,
    transform: "translate(0 7.105)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16024",
    "data-name": "Path 16024",
    d: "M12.291,14.1l3.648-.73a.364.364,0,0,0,.219-.577h0a.364.364,0,0,0-.234-.14l-3.886-.606a.2.2,0,0,1-.165-.229.208.208,0,0,1,.235-.162l2.695.355a.235.235,0,0,0,.2-.394l-.216-.231a.562.562,0,0,0-.3-.168l-2.251-.436,1.919.138a.164.164,0,0,0,.134-.273l-.1-.11a.418.418,0,0,0-.226-.13l-1.905-.4,1.354-.039a.141.141,0,0,0,.1-.235l-.061-.068a.379.379,0,0,0-.178-.111l-1.208-.347h.949a.13.13,0,0,0,.12-.182L13.1,8.957a.342.342,0,0,0-.2-.188l-.878-.3h.432a.179.179,0,0,0,.163-.25h0A.449.449,0,0,0,12.41,8l-.963-.5-.963.5a.449.449,0,0,0-.205.22h0a.179.179,0,0,0,.163.25h.432l-.878.3a.342.342,0,0,0-.2.188l-.032.074a.13.13,0,0,0,.12.182h.949L9.622,9.56a.379.379,0,0,0-.178.111l-.061.068a.141.141,0,0,0,.1.235l1.354.039-1.905.4a.418.418,0,0,0-.226.13l-.1.11a.164.164,0,0,0,.134.273l1.919-.138-2.251.436a.562.562,0,0,0-.3.168l-.216.231a.235.235,0,0,0,.2.394l2.695-.355a.208.208,0,0,1,.235.162.2.2,0,0,1-.165.229l-3.886.606a.364.364,0,0,0-.234.14h0a.364.364,0,0,0,.219.577l3.648.73v.455a.937.937,0,0,1-.274.663l-.569.569h3.374l-.569-.569a.937.937,0,0,1-.274-.663V14.1h0Z",
    fill: "#73af00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag1);
export default __webpack_public_path__ + "static/media/flag1.62a0037f9e970df7cc14410be8806cd2.svg";
export { ForwardRef as ReactComponent };